export default "__VITE_ASSET__C32vXkL$__"